import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { AuthState } from "./types";
import { RootState } from "../types";

const namespaced = true;

export const state: AuthState = {
  authUser: null,
};

export const auth: Module<AuthState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
